import { render, staticRenderFns } from "./MonthlyTaxCIMB.vue?vue&type=template&id=750aaf93&scoped=true"
import script from "./MonthlyTaxCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750aaf93",
  null
  
)

export default component.exports